import { render, staticRenderFns } from "./CreateLoyaltyTier.vue?vue&type=template&id=be5a0832&"
import script from "./CreateLoyaltyTier.vue?vue&type=script&lang=js&"
export * from "./CreateLoyaltyTier.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports